import { UserStatus } from "@/api/forms";
import { api } from "../api";
import { backendErrors } from "./common";
import { makeAnalytics } from "../analytics";

export const EDUCATION_STEPS = {
  FIRST_STEP: "FIRST_STEP",
  SECOND_STEP: "SECOND_STEP",
  THANK_YOU_STEP: "THANK_YOU_STEP"
};

export const EDUCATION_TYPE = {
  SEMINAR: "SEMINAR",
  WEBINAR: "WEBINAR"
};

const educationSeminarThankYou = async (formData: any, prevResponse: any) => {
  await api.forms.triggerEvents({
    events: ["App\\Events\\SeminarRegistrationWAM"],
    fields: {
      formData,
      callResponse: prevResponse
    }
  });

  const { data: thankYouData } = await api.forms.seminarThankYou({
    user_id: prevResponse.id,
    preDefinedPayload: formData.preDefinedPayload
  });

  const data = { ...prevResponse, ...thankYouData };

  const analytics = makeAnalytics();

  analytics.gtm.pushData({
    event: "Edu Event Success",
    client_id: data.client_id,
    profile_id: data.profile_id
  });

  return {
    next: EDUCATION_STEPS.THANK_YOU_STEP,
    data: data
  };
};

const educationWebinarThankYou = async (formData: any, prevResponse: any) => {
  const { data } = await api.forms.triggerEvents({
    events: ["App\\Events\\WebinarRegistrationWAM"],
    fields: {
      formData,
      callResponse: prevResponse
    }
  });

  const { data: clientData } = await api.forms.getClientId({
    email: formData.email
  });

  const d = { ...prevResponse, ...data, ...clientData };

  const analytics = makeAnalytics();

  analytics.gtm.pushData({
    event: "Edu Event Success",
    client_id: d.client_id,
    profile_id: d.profile_id
  });

  return {
    next: EDUCATION_STEPS.THANK_YOU_STEP,
    data: d
  };
};

export const educationFirstStep = async (data: UserStatus, type: string) => {
  const { data: response } = await api.forms.getProfileInfo(data);

  if (response.errors) {
    throw { errors: backendErrors(response.errors) };
  }

  response.isNewClient = !response.success;

  if (!response.success || !response.first_name || !response.last_name) {
    return {
      next: EDUCATION_STEPS.SECOND_STEP,
      data: response
    };
  }

  if (type === EDUCATION_TYPE.WEBINAR) {
    return educationWebinarThankYou(data, response);
  }

  return educationSeminarThankYou(data, response);
};

export const educationSecondStep = async (data: any, type: string) => {
  let prevResponse = data;
  if (!data.hasOwnProperty("isNewClient") || data.isNewClient === true) {
    const { data: leadData } = await api.forms.registerLead(data);

    if (leadData.errors) {
      throw { errors: backendErrors(leadData.errors) };
    }

    prevResponse = leadData;
  }

  if (type === EDUCATION_TYPE.WEBINAR) {
    return educationWebinarThankYou(data, prevResponse);
  }

  return educationSeminarThankYou(data, prevResponse);
};

export const educationMarketingEmails = async (data: any) => {
  const { data: response } = await api.forms.marketingEmails(data);

  return response.success;
};
